import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import Modal from "../../components/Genericos/Modal/Modal";
import SegundoModal from "../../components/Genericos/SegundoModal/SegundoModal";
import { Network } from "@capacitor/network";
import "./LoginStyle.css";
import MantenimientoCard from "../../components/Genericos/MantenimientoCard/MantenimientoCard";
import { GlobalContext } from "../../../global/context/Provider";
import SinRed from "_+_Portal/components/Genericos/SinRed/SinRed";
import LoginBoxV2 from "_+_Portal/components/Auth/LoginBoxV2/LoginBoxV2";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import DesktopLoginLayout from "./DesktopLoginLayout";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";
import styled from "styled-components";
import { useHistory } from "react-router";
import { getLocalStorage } from "global/utils/safeJsonParse";

const TabletKeyboardOverlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0 24px 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0.25) 100%
  );
`;

const CloseKbButton = styled.button`
  position: absolute;
  top: -44px;
  right: 24px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: none;
  background: var(--color-danger);
  color: var(--color-white);
  cursor: pointer;
`;

const ResetTAGBox = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: initial;
`;

const Layout = ({
  error,
  form,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
}) => {
  const { modalState, segundoModalState } = useContext(PortalContext);
  const { toasterState } = useContext(GlobalContext);
  const [flgBox, setFlgBox] = useState(false);
  const [network, setNetwwork] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);
  const [showTabletKeyboard, setShowTabletKeyboard] = useState(false);
  const [resetCount, setResetCount] = useState(1);
  const history = useHistory();

  //configuracion de portal en mantenimiento, al json lo lee de la carpeta public
  useEffect(() => {
    setFlgBox(true);
  }, []);

  const config = getLocalStorage("config", {});
  let mantenimiento = config?.mantenimiento;

  // Listener de red: verifica conexión y escucha cambios
  useEffect(() => {
    let isMounted = true;

    // Obtener estado inicial de red
    Network.getStatus().then((status) => {
      if (isMounted) {
        setNetwwork(status.connected);
      }
    });

    // Escuchar cambios en el estado de red
    const listener = Network.addListener("networkStatusChange", (status) => {
      if (isMounted) {
        let config = getLocalStorage("config", {});
        const dtoMantenimiento = {
          mantenimiento: false,
          mantenimientoMsj:
            "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
        };
        config = { ...config, ...dtoMantenimiento };
        localStorage.setItem("config", JSON.stringify(config));
        setNetwwork(status.connected);
      }
    });

    // Cleanup: remover listener y marcar como desmontado
    return () => {
      isMounted = false;
      listener.then((handle) => handle.remove());
    };
  }, []);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isDesktop = width >= 1280;
  const isTablet = width >= 1024 && width < 1280;

  // Mostrar teclado en tablet cuando el input nro_documento toma foco
  useEffect(() => {
    if (!isTablet) {
      setShowTabletKeyboard(false);
      return;
    }
    const onFocusIn = (e) => {
      const target = e.target;
      if (
        target &&
        target.getAttribute &&
        target.getAttribute("name") === "nro_documento"
      ) {
        setShowTabletKeyboard(true);
      }
    };
    const onKeyDown = (e) => {
      // Tecla Escape cierra el teclado
      if (e.key === "Escape") {
        setShowTabletKeyboard(false);
      }
    };
    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      document.removeEventListener("focusin", onFocusIn, true);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, [isTablet]);

  const resetTag = () => {
    setResetCount(resetCount + 1);
    if (resetCount === 3) {
      localStorage.removeItem("dataComplete");
      localStorage.removeItem("idTerminal");
      history.push("/checkinConfig");
    }
  };

  const nroDocumentoValue = Array.isArray(form)
    ? form.find((f) => f?.name === "nro_documento")?.value || ""
    : "";

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <ResetTAGBox onClick={() => resetTag()} />
      <div className="loginContainer">
        {flgBox &&
          (mantenimiento || !network ? (
            !network ? (
              <SinRed />
            ) : mantenimiento ? (
              <MantenimientoCard />
            ) : (
              <></>
            )
          ) : isDesktop ? (
            <DesktopLoginLayout
              form={form}
              onChange={onChange}
              onSubmit={onSubmit}
              loginFormValid={loginFormValid}
              loading={loading}
              error={error}
            />
          ) : (
            <LoginBoxV2
              form={form}
              onChange={onChange}
              onSubmit={onSubmit}
              loginFormValid={loginFormValid}
              loading={loading}
              error={error}
            />
          ))}
        {isTablet && showTabletKeyboard && (
          <TabletKeyboardOverlay>
            <CloseKbButton onClick={() => setShowTabletKeyboard(false)}>
              Cerrar teclado
            </CloseKbButton>
            <Keyboard
              value={nroDocumentoValue}
              onChange={(next) =>
                onChange({ target: { name: "nro_documento", value: next } })
              }
              onEnter={() => loginFormValid && onSubmit(form)}
              maxLength={8}
              enableFrom={7}
            />
          </TabletKeyboardOverlay>
        )}
        {/* </div> */}
      </div>
    </React.Fragment>
  );
};

export default Layout;
